import React from 'react';
import { string, func, node } from 'prop-types';
import { isEmpty } from 'lodash';

import TableRow from '../../../../Components/GenericTable/TableRow';
import TableCell from '../../../../Components/GenericTable/TableCell';

import { contactType } from '../types';

import PrimarySearchRow from './PrimarySearchRow';
import ContactDetails from './ContactDetails';
import CurrentSupervision from './CurrentSupervision';
import { CurrentLicencesContent } from './CurrentLicences';
import { CurrentEndorsementsContent } from './CurrentEndorsements';
import LicenceHistory from './LicenceHistory';
import EndorsementHistory from './EndorsementHistory';
import RegistrationHistory from './RegistrationHistory';
import DisciplinaryHistory from './DisciplinaryHistory';

// count of data (ignores button in first cell)
const TABLE_COL_COUNT = 4;

export const DetailedRow = ({ children }) => {
   return (
      <TableRow className="pr-row-no-border pr-row-no-top-pad pr-highlighted-result">
         <TableCell className="pr-row-no-vert-pad" />
         <TableCell
            className="pr-row-no-vert-pad pr-row-right-pad"
            colspan={TABLE_COL_COUNT}
         >
            {children}
         </TableCell>
      </TableRow>
   );
};

DetailedRow.propTypes = {
   children: node.isRequired,
};

export const DetailedRowContent = ({ children }) => {
   return (
      <div className="row pr-row-left-indent small pr-row-small-mb">
         {children}
      </div>
   );
};

DetailedRowContent.propTypes = {
   children: node.isRequired,
};

export const SectionHeader = ({ label }) => {
   return (
      <div className="row pr-row-section-header bold">
         <div className="col s12">
            <span>{label}</span>
         </div>
      </div>
   );
};

SectionHeader.propTypes = {
   label: string.isRequired,
};

// empty content so that we have spacing to the next result (or end of results)
const DetailedRowFooter = () => {
   return (
      <TableRow className="pr-row-no-top-pad pr-highlighted-result">
         <TableCell
            className="pr-row-no-vert-pad pr-row-right-pad"
            colspan={TABLE_COL_COUNT + 1} // +1 for the extra column containing expand/collapse
         >
            <div className="pr-advanced-row-footer" />
         </TableCell>
      </TableRow>
   );
};

const DetailedSearchRow = ({ contact, onCollapse }) => {
   return (
      <>
         <PrimarySearchRow
            contact={contact}
            icon="expand_less"
            onToggle={onCollapse}
            rowStyle="pr-row-no-border pr-highlighted-result pr-row-hover"
         />
         {(!isEmpty(contact.licences) || !isEmpty(contact.endorsements)) && (
            <DetailedRow>
               <div className="row">
                  {!isEmpty(contact.licences) && (
                     <div className={!isEmpty(contact.endorsements) ? 'col s6' : 'col s12'}>
                        <CurrentLicencesContent licences={contact.licences} />
                     </div>
                  )}
                  {!isEmpty(contact.endorsements) && (
                     <div className="col s6">
                        <CurrentEndorsementsContent endorsements={contact.endorsements} />
                     </div>
                  )}
               </div>
            </DetailedRow>
         )}
         {contact.disciplinaryHistory &&
            !isEmpty(contact.disciplinaryHistory.history) && (
               <DisciplinaryHistory
                  disciplinaryHistory={contact.disciplinaryHistory.history}
               />
            )}
         {!isEmpty(contact.licences) && <ContactDetails contact={contact} />}
         {!isEmpty(contact.registrationHistory) && (
            <RegistrationHistory history={contact.registrationHistory} />
         )}
         {!isEmpty(contact.licenceHistory) && (
            <LicenceHistory history={contact.licenceHistory} />
         )}
         {!isEmpty(contact.endorsementHistory) && (
            <EndorsementHistory history={contact.endorsementHistory} />
         )}
         {!isEmpty(contact.supervisees) && (
            <CurrentSupervision
               firstName={contact.firstName}
               supervisees={contact.supervisees}
            />
         )}
         <DetailedRowFooter />
      </>
   );
};

DetailedSearchRow.propTypes = {
   contact: contactType.isRequired,
   onCollapse: func.isRequired,
};

export default DetailedSearchRow;
